














































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import EyeIcon from 'mdi-vue/Eye';
import EyeCloseIcon from 'mdi-vue/EyeOff';
import api from '@/libs/api';

@Component({
  components: {
    Button,
    EyeIcon,
    EyeCloseIcon,
  },
})
export default class FormInput extends Vue {
  @Prop({ type: String, default: '' }) readonly variant!: string;
  @Prop(String) readonly rules!: string;
  @Prop({ default: false }) readonly disabled!: string;
  @Prop({ default: '' }) readonly error!: string;
  @Prop(Object) readonly customErrorMessages: undefined | { [key: string]: string };
  @Prop(String) readonly id!: string;
  @Prop(Number) readonly maxlength!: number;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly value!: string;
  @Prop(String) readonly vid!: string;
  @Prop({ type: Number, default: 6 }) readonly maxSize!: number;
  @Prop(String) readonly accept!: string;

  $refs!: {
    id: HTMLInputElement;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  env: any;

  imageName = ''
  image = ''

  mounted() {
    if (this.$route.path.includes('merchant-lead')) {
      this.env = process.env.VUE_APP_SANDBOX_API_URL;
    } else {
      this.env = process.env.VUE_APP_API_URL;
    }
    if (this.value && this.value !== '' && this.value !== '-') {
      this.image = this.env + this.value;
      this.imageName = this.value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showImage(val: any) {
    // console.log('cek ext', this.isPdf(this.imageName));
    if (this.isPdf(this.imageName)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const w: any = window.open(val, '_blank')?.focus();
      if (w) {
        w.focus();
      }
    } else {
      this.$emit('show', val);
    }
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  async onFileChange(e: any) {
    const file = e.target.files[0];
    const image = new FormData();
    image.append('image', file);
    this.image = URL.createObjectURL(file);
    const { data } = await api.post('/upload', image);
    this.imageName = data;
    this.$emit('filename', [this.id, this.imageName]);
    this.$emit('change', file);
  }

  reset() {
    this.image = '';
  }

  isPdf = (val: string) => {
    const ext = val.substring(val.length - 3, val.length);
    // console.log('ext', ext, val);
    return ext === 'pdf';
  }
}
